import {
  WAREHOUSE_FETCHING,
  WAREHOUSE_RECEIVED,
  WAREHOUSE_ERROR,
  WAREHOUSE_SELECTED,
  PRODUCT_SEARCH,
} from '../actions/warehouse-action-types';
import { CURRENT_WAREHOUSE_STORAGE_KEY, Warehouse } from '../services/warehouse';
import { WarehouseAction } from '../actions/warehouse';
import { WarehouseState } from './typings';

function getCurrentWarehouse(): Warehouse | null {
  const currentWarehouse = localStorage.getItem(CURRENT_WAREHOUSE_STORAGE_KEY);
  if (currentWarehouse) {
    return JSON.parse(currentWarehouse);
  }
  return null;
}

function getInitialState(): WarehouseState {
  const initialState: WarehouseState = {
    warehouseId: -1,
    warehouseName: '',
    warehouseOdooLocationId: '',
    isFetching: false,
    error: null,
    currentMenu: null,
    searchInput: '',
  };

  const currentWarehouse = getCurrentWarehouse();
  if (currentWarehouse) {
    initialState.warehouseId = currentWarehouse.id;
    initialState.warehouseName = currentWarehouse.name;
    initialState.warehouseOdooLocationId = currentWarehouse.odoo_location_id;
  }

  return initialState;
}

export const initialState = getInitialState();

function warehouse(state = initialState, action: WarehouseAction) {
  switch (action.type) {
    case WAREHOUSE_FETCHING:
      return { ...state, isFetching: true, content: {} };
    case WAREHOUSE_RECEIVED:
      return {
        ...state,
        currentMenu: action.payload,
        isFetching: false,
        error: null,
      };
    case WAREHOUSE_ERROR:
      return { ...state, error: action.error.toString(), isFetching: false };
    case WAREHOUSE_SELECTED:
      return {
        ...state,
        warehouseId: action.warehouseId,
        warehouseName: action.warehouseName,
      };
    case PRODUCT_SEARCH:
      return { ...state, searchInput: action.text.toLowerCase() };
    default:
      return state;
  }
}
export default warehouse;
